// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"4e555043","232":"f93225c6","396":"716ff536","420":"7abd9cbe","456":"6a301b70","568":"46885ff3","684":"86cfec9d"}[chunkId] + ".css";
};